export default function DoraLogin() {
  const handleDoraLogin = () => {
    window.location.href = `${import.meta.env.VITE_SNAKE_CHARMER_URL}`
  }
  return(
    <div
      className="text-fpx-red hover:opacity-75 hover:cursor-pointer underline"
      onClick={() => handleDoraLogin()}
    >
      Login to Dora
    </div>
  )
}